import { render, staticRenderFns } from "./LocalizableTextArea.vue?vue&type=template&id=5fb81d32&scoped=true"
import script from "./LocalizableTextArea.vue?vue&type=script&lang=ts"
export * from "./LocalizableTextArea.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb81d32",
  null
  
)

export default component.exports